import InventoryListPage from 'domains/inventory/pages/inventory-list-page'
import InventoryDetailPage from 'domains/inventory/pages/inventory-detail-page'
import InventoryEditPage from 'domains/inventory/pages/inventory-edit-page'
import {
  SellerOutboundReturnCreatePage
} from 'domains/seller-outbound-return/pages'
import StockOpnameListPage from 'domains/stock-opname/pages/stock-opname-list-page/stock-opname-list-page'
import StockOpnameDetailPage from 'domains/stock-opname/pages/stock-opname-detail-page/stock-opname-detail-page'
import StockOpnameCreatePage from 'domains/stock-opname/pages/stock-opname-create-page/stock-opname-create-page'
import StockOpnameEntryEditPage from 'domains/stock-opname-entry/pages/stock-opname-entry-edit-page/stock-opname-entry-edit-page'
import StockOpnameEntryListPage from 'domains/stock-opname-entry/pages/stock-opname-entry-list-page/stock-opname-entry-list-page'
import { SalesCashHandoverReceiptsDetailPage, SalesCashHandoverReceiptsListPage } from 'domains/sales/cash-handover-receipts/pages'
import all_team_internal_request_routes from './internal-requests'
import React from 'react'
import Phase3TandaMasukPage from 'domains/phase3-inbound-journey/pages/Phase3TandaMasukPage'
import Phase3InventoryBatchPage from 'domains/phase3-inbound-journey/pages/Phase3InventoryBatchPage'
import Phase3ProductQueuePage from 'domains/phase3-inbound-journey/pages/Phase3ProductQueuePage'
import Phase3ConsignmentListPage from 'domains/phase3-inbound-journey/pages/Phase3ConsignmentListPage'
import Phase3ConsignmentEditPage from 'domains/phase3-inbound-journey/pages/Phase3ConsignmentEditPage'
import { PHASE3_PRODUCT_SCOPES } from 'domains/phase3-inbound-journey/constants'

const all_team_routes = {
  collapse  : true,
  path      : '/all-team',
  name      : 'All Team',
  icon      : 'fas fa-users text-primary',
  state_key : 'all_team_collapse',
  views     : [

    {
      collapse  : true,
      name      : 'Inbound Journey',
      miniName  : 'IJ',
      state_key : 'all_team_inbound_journey_collapse',
      views     : [
        {
          path      : '/inbound-journey/tanda-masuk',
          name      : 'Tanda Masuk',
          miniName  : 'TM',
          component : (props) => <Phase3TandaMasukPage { ...props } apiNamespace='all_team' />,
          layout    : '/app'
        },
        {
          path      : '/sales/cash-handover-receipts',
          name      : 'Tanda Terima General',
          miniName  : 'TTG',
          component : SalesCashHandoverReceiptsListPage,
          layout    : '/app'
        },
        {
          path      : '/sales/cash-handover-receipts/:id',
          name      : 'Tanda Terima General Detail',
          miniName  : 'TTG',
          component : SalesCashHandoverReceiptsDetailPage,
          layout    : '/app',
          invisible : true
        },
        {
          path      : '/all-team/inbound-journey/inventory-batches',
          name      : 'Inventory Batch',
          miniName  : 'IB',
          component : (props) => <Phase3InventoryBatchPage { ...props } apiNamespace='all_team' />,
          layout    : '/app'
        },
        {
          path      : '/inbound-journey/ready-for-inbound',
          invisible : true,
          name      : 'Ready For Inbound',
          miniName  : 'RI',
          component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.READY_FOR_INBOUND } title='Ready For Inbound' apiNamespace='all_team' />,
          layout    : '/app'
        },
        {
          path      : '/inbound-journey/waiting-for-inbound',
          invisible : true,
          name      : 'Waiting For Inbound',
          miniName  : 'WI',
          component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.WAITING_FOR_INBOUND } title='Waiting For Inbound' apiNamespace='all_team' />,
          layout    : '/app'
        },
        {
          path      : '/inbound-journey/inbound-completed',
          invisible : true,
          name      : 'Completed',
          miniName  : 'CP',
          component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.INBOUND_COMPLETED } title='Completed' apiNamespace='all_team' />,
          layout    : '/app'
        },
        {
          path      : '/inbound-journey/live',
          name      : 'Live Products',
          miniName  : 'LV',
          component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.LIVE } title='Live Products' apiNamespace='all_team' />,
          layout    : '/app'
        },
        {
          path      : '/inbound-journey/deleted',
          name      : 'Deleted',
          miniName  : 'DL',
          component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.DELETED } title='Deleted Products' apiNamespace='all_team' />,
          layout    : '/app'
        },
        {
          path      : '/inbound-journey/unprocessed',
          name      : 'Unprocessed',
          miniName  : 'UP',
          component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.UNPROCESSED } title='Unprocessed Products' apiNamespace='all_team' />,
          layout    : '/app'
        },
        {
          path      : '/inbound-journey/incoming',
          name      : 'Incoming',
          miniName  : 'IN',
          component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.INCOMING } title='Incoming Products' apiNamespace='all_team' />,
          layout    : '/app'
        },
        {
          path      : '/inbound-journey/bkt',
          name      : 'BKT',
          miniName  : 'BKT',
          component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.BKT } title='BKT / Multi Quantity' apiNamespace='all_team' />,
          layout    : '/app'
        }
      ]
    },
    {
      collapse  : true,
      name      : 'Consignments',
      miniName  : 'CS',
      state_key : 'all_team_consignments_collapse',
      views     : [
        {
          path      : '/all-team/consignments',
          name      : 'View List',
          miniName  : 'VL',
          component : (props) => <Phase3ConsignmentListPage { ...props } apiNamespace='all_team' />,
          layout    : '/app'
        },
        {
          path      : '/all-team/consignments/:id/edit',
          name      : 'Edit Consignment',
          miniName  : 'EC',
          component : (props) => <Phase3ConsignmentEditPage { ...props } apiNamespace='all_team' />,
          layout    : '/app',
          invisible : true
        }
      ]
    },
    {
      path      : '/warehouse-team/inventory/list-page',
      name      : 'Inventory List',
      miniName  : 'IL',
      component : InventoryListPage,
      layout    : '/app'
    },
    {
      path      : '/warehouse-team/inventory/:id/edit-page',
      name      : 'Edit Inventory',
      miniName  : 'EditInv',
      component : InventoryEditPage,
      layout    : '/app',
      invisible : true
    },
    {
      path      : '/warehouse-team/inventory/:id',
      name      : 'Inventory Detail',
      component : InventoryDetailPage,
      layout    : '/app',
      invisible : true
    },
    {
      collapse  : true,
      name      : 'Internal Request',
      miniName  : 'IR',
      state_key : 'all_team_inventory_internal_request_collapse',
      views     : all_team_internal_request_routes
    },
    // {
    //   collapse  : true,
    //   name      : 'Consignor Return',
    //   miniName  : 'CR',
    //   state_key : 'all_team_seller_return_collapse',
    //   views     : [
    //     {
    //       path      : '/seller-outbound-returns/create',
    //       name      : 'Create Request',
    //       miniName  : 'CR',
    //       component : SellerOutboundReturnCreatePage,
    //       layout    : '/app'
    //     }
    //   ]
    // },
    {
      collapse  : true,
      name      : 'Stock Opname',
      miniName  : 'SO',
      state_key : 'all_team_stock_opname_collapse',
      views     : [
        {
          path      : '/stock-opnames/list-page',
          name      : 'List',
          miniName  : 'L',
          component : StockOpnameListPage,
          layout    : '/app'
        },
        {
          path      : '/stock-opname-entries/list-page',
          name      : 'Entries',
          miniName  : 'E',
          component : StockOpnameEntryListPage,
          layout    : '/app'
        },
        {
          path      : '/stock-opnames/new',
          name      : 'New',
          miniName  : 'N',
          component : StockOpnameCreatePage,
          layout    : '/app',
          invisible : true
        },
        {
          path      : '/stock-opnames/:id',
          name      : 'Detail',
          component : StockOpnameDetailPage,
          layout    : '/app',
          invisible : true
        },
        {
          path      : '/stock-opname-entries/:id/edit-page',
          name      : 'Entry Edit',
          component : StockOpnameEntryEditPage,
          layout    : '/app',
          invisible : true
        }
      ]
    }
  ]
}

export default all_team_routes
